import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { pageFaqs } from '../../data/faqs';

const ServicesFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const faqs = pageFaqs['/services'];

  return (
    <section className="py-24 bg-white border-t border-[#EAF1EC]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="mb-16 text-center text-4xl leading-tight text-[#17211E] sm:text-5xl">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div key={i} className="border border-[#EAF1EC] rounded-2xl overflow-hidden">
              <button 
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                aria-expanded={openIndex === i}
                aria-controls={`faq-answer-${i}`}
                className="w-full flex justify-between items-center p-6 text-left hover:bg-[#FAF8F3] transition-colors"
              >
                <span className="text-lg font-bold text-[#17211E]">{faq.q}</span>
                <SafeIcon icon={FiChevronDown} className={`w-6 h-6 text-[#3B7C6D] transition-transform ${openIndex === i ? 'rotate-180' : ''}`} />
              </button>
              <div
                id={`faq-answer-${i}`}
                className={`px-6 pb-6 text-lg text-[#17211E]/75 font-medium leading-relaxed ${openIndex === i ? 'block' : 'hidden'}`}
              >
                {faq.a}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesFAQ;